import bgDark from '@/assets/BackgroundImageDark.png';
import bgLight from '@/assets/BackgroundImageLight.png';
import { useTheme } from '@/hooks/use-Theme';

const AppBackground = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  const imgSrc = isDarkMode ? bgDark : bgLight;

  return (
    <>
      <div
        className="absolute top-0 left-0 w-full h-full bg-cover bg-no-repeat bg-center "
        style={{
          backgroundImage: `url(${imgSrc})`,
          opacity: isDarkMode ? 0.1 : 0.7,
          zIndex: -1,
        }}></div>
    </>
  );
};

export default AppBackground;
